{
	"dateInfoNotAvailable": "Visualización no disponible",
	"monthDays": "Total {{monthDays}} días"
}
